import { oz } from '@weft/utils';

export const OAuth2DataSchema = oz.object({
  state: oz.string().optional(),
  redirectUrl: oz.string().optional(),
  accessToken: oz.string().optional(),
  refreshToken: oz.string().optional(),
  expiresAt: oz.date().optional(),
});

export type OAuth2Data = oz.infer<typeof OAuth2DataSchema>;